import { render, staticRenderFns } from "./CriteriaPage.vue?vue&type=template&id=2f00f92c&scoped=true"
import script from "./CriteriaPage.vue?vue&type=script&lang=ts"
export * from "./CriteriaPage.vue?vue&type=script&lang=ts"
import style0 from "./CriteriaPage.vue?vue&type=style&index=0&id=2f00f92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00f92c",
  null
  
)

export default component.exports